module.exports = __webpack_public_path__ + "img/02.cfb8a6d5.png";